'use strict';

import { Record } from 'immutable';
import Storeys from '../common/storeys';

const GeoObject = Record({
  id: null,
  name: '',
  fullName: '',
  shortName: ''
}, 'GeoObject');

GeoObject.makePopupItem = function (data) {
  const property = data.getProperty();
  const location = property.getGeoLocation();
  const street = location.getStreet() && location.getStreet().fullName;
  const houseName = location.getBuilding() && location.getBuilding().name;
  const type = property.getType();
  const point = location.getGeoPoint();

  const room = property.getRoom();
  const storeys = new Storeys(room.getFloorNumber(), property.getBuilding().getFloorsNumberAboveGround());

  const totalArea = room.getTotalArea();
  const landArea = property.getLandPlot().getTotalArea();

  const body = [
    type ? type.get('middleName') : null,
    totalArea ? 'пл. ' + totalArea.getLabel(false) : null,
    landArea ? 'уч. ' + landArea.getLabel(false) : null,
    storeys.getLabel(Storeys.TYPE_SHORT)
  ].filter(Boolean).join(', ');

  return {
    id: data.getProperty().getId(),
    lon: (point && parseFloat(point.get(0))) || null,
    lat: (point && parseFloat(point.get(1))) || null,

    url: data.getLink(),
    photo: data.getMainPhoto(),
    photoAlt: location.getShortAddress(),
    header: data.getPrice().getLabel(),
    body,
    footer: [street, houseName].filter(Boolean).join(', ')
  };
};

export default GeoObject;



// WEBPACK FOOTER //
// ./src/classes/geo/geoObject.js